import { LoginCallback } from '@okta/okta-react';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/implicit/callback')({
  component: LoginCallback,
});
